export default "__VITE_ASSET__DH4zaTyD__"